import { render, staticRenderFns } from "./WoocommyMenu.vue?vue&type=template&id=a2ebe2e6&"
import script from "./WoocommyMenu.vue?vue&type=script&lang=js&"
export * from "./WoocommyMenu.vue?vue&type=script&lang=js&"
import style0 from "./WoocommyMenu.vue?vue&type=style&index=0&id=a2ebe2e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports